/** `NZ-LOGBOOK.md` §3: settable so a pilot can start the app mid-career without entering thirty years of history. */
export const LOGBOOK_OPENING_BALANCE_KEY = 'logbook.openingBalanceHr';

/** `ExpiryReminder[]` (`currency.ts`) — logbook-specific data edited on the currency page, not a display preference, so it lives here rather than in `AppSettings` the same way the opening balance does. */
export const LOGBOOK_CURRENCY_REMINDERS_KEY = 'logbook.currencyReminders';
